import type { VoidFunctionComponent } from "react";
import Tooltip from "../../../generic/Tooltip";

import styles from './UserEmail.module.less';

type UserEmailProps = {
  userEmail: string;
};

/**
 * Add a tooltip on user email.
 */
export const UserEmail: VoidFunctionComponent<UserEmailProps> = ({ userEmail }) => (
  <Tooltip id="ignoredBy" tooltip={<div>{userEmail}</div>}>
    <span className={`bold ${styles.userEmail}`}>{userEmail}</span>
  </Tooltip>
);
